import { render, staticRenderFns } from "./ListResources.vue?vue&type=template&id=2936674e&"
import script from "./ListResources.vue?vue&type=script&lang=js&"
export * from "./ListResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports